export const MAX_DESKTOP_CONTENT_WIDTH = 940;
export const MAX_DESKTOP_CONTENT_HEIGHT = 640;

export const SUPPORT_LINK = 'https://styleseat.freshdesk.com/support/home';
export const SWITCHED_FROM_PREMIUM_TO_BASIC = 'switched_from_premium_to_basic';
